// import Select2 from 'react-select'; 로 쓰고 있는 <Selct2> 컴포넌트 다크모드 공통 스타일 적용
export const getSelect2Styles = (darkModeStatus) => ({
    menu: (base) => ({
        ...base,
        backgroundColor: darkModeStatus ? '#1f2128' : 'white',
        color: darkModeStatus ? '#fff' : '#333',
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: '150px',
        overflowY: 'auto',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
        ? (darkModeStatus ? '#4f4f50ff' : '#2684FF')
        : state.isFocused
        ? (darkModeStatus ? '#333' : '#f0f0f0')
        : 'transparent',
        // color: darkModeStatus ? '#fff' : '#333',
        cursor: 'pointer',
        ':active': {
            backgroundColor: darkModeStatus ? '#333' : '#B2D4FF',
        },
    }),
});